module.exports = __webpack_public_path__ + "img/賴品妤.9d8cefd4.png";